import React, { useState } from "react";
import { Package } from "lucide-react";

/**
 * Square product image with placeholder fallback.
 * - Renders an <img> when src is provided AND loads correctly.
 * - On error or empty src, shows a neutral placeholder with a package icon.
 *
 * Props:
 *   src         (string|null) image URL
 *   alt         (string)      alt text
 *   size        (string)      tailwind size class for w/h. default 'w-12 h-12'
 *   className   (string)      extra classes for outer wrapper
 */
export function ProductImage({ src, alt = "", size = "w-12 h-12", className = "" }) {
  const [errored, setErrored] = useState(false);
  const showImg = src && !errored;
  return (
    <div
      className={`shrink-0 ${size} bg-secondary border border-border rounded-sm overflow-hidden flex items-center justify-center ${className}`}
      data-testid="product-image"
    >
      {showImg ? (
        <img
          src={src}
          alt={alt}
          className="w-full h-full object-cover"
          loading="lazy"
          onError={() => setErrored(true)}
          data-testid="product-image-img"
        />
      ) : (
        <Package size={20} className="text-muted-foreground" strokeWidth={1.5} data-testid="product-image-placeholder" />
      )}
    </div>
  );
}

export default ProductImage;
